import state from './state'
import mutations from './mutations'

export const appElement = {
  namespaced: true,
  state,
  mutations
}
